'use strict';

export const http = (value = '') => {
  const regExp = /^https?:\/\/(www\.)?[a-zA-Z0-9]{1}[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,15}\b[-a-zA-Z0-9()@:%_+.~#?&\/=]*$/;
  return ! regExp.test(String(value).toLowerCase());
};

export const email = (value = '') => {
  const regExp = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
  return regExp.test(String(value).toLowerCase());
};

export const phone = (value = '') => {
  const regExp = /^\+\d{11}/g;
  return regExp.test(String(value).toLowerCase());
};
